// Built-in dashboard roles whose NAME carries behavior, mirroring the
// backend's src/config/roles.js. The only place the dashboard compares role
// names; components ask these helpers instead.

export const ROLES = Object.freeze({
  ADMIN: "Admin",
  TOP_LEADER: "Top-Leader",
  LEADER: "Leader",
  CO_LEADER: "Co-Leader",
  FINALS_EXECUTER: "Finals-Executer",
  CUSTOMER_SERVICE: "Customer-Service",
  OBSERVER: "Observer",
  CHAT_ADMIN: "Chat-Admin",
  OWNER: "Owner",
});

const nameOf = (role) => String(role || "").trim();

// The top roles (Owner and Admin, identical in power): hold every permission,
// manage every account, and are the only ones that edit roles.
const TOP_ROLES = [ROLES.OWNER, ROLES.ADMIN];
export const isTopRole = (role) => TOP_ROLES.includes(nameOf(role));

// An Owner account can't be deleted, keeps its role, is edited only by that
// Owner, and only an Owner gives the Owner role (backend: checkRoleHierarchy).
export const isOwnerRole = (role) => nameOf(role) === ROLES.OWNER;

export const isBuiltInRole = (role) => Object.values(ROLES).includes(nameOf(role));

// The set executor: offered in the executor pickers, works only its assigned
// sets, and has nobody under it in the hierarchy.
export const isSetExecutorRole = (role) => nameOf(role) === ROLES.CO_LEADER;

// Hierarchy: only Top-Leaders and Leaders have admins under them, and only
// admins ranked below their own role.
const HIERARCHY_RANK = {
  [ROLES.OWNER]: 0,
  [ROLES.ADMIN]: 0,
  [ROLES.TOP_LEADER]: 1,
  [ROLES.LEADER]: 2,
};
const rankOf = (role) => HIERARCHY_RANK[nameOf(role)] ?? 3;

export const canHaveSubordinates = (role) =>
  [ROLES.TOP_LEADER, ROLES.LEADER].includes(nameOf(role));

export const canBePlacedUnder = (parentRole, childRole) =>
  canHaveSubordinates(parentRole) && rankOf(childRole) > rankOf(parentRole);
